import { Observable, Subscriber } from "rxjs";
import { Page } from "../../page";

export abstract class CriteriaSearchComponent<T> {
  private subscribers: Subscriber<T>[] = [];

  public criteriaLoading = false;

  public results!: Page<T>;
  public query = "";

  constructor(public displayName: string, private onSearch: (query: string) => Observable<Page<T>>) {
    this.search();
  }

  public abstract formatResult(result: T): string;

  public abstract formatResultsMetadataLabel(): string;

  public addFilter(filterValue: T) {
    for (const subscriber of this.subscribers) {
      subscriber.next(filterValue);
    }
  }

  public onFilterAdded(): Observable<T> {
    return new Observable<T>(subscriber => { this.subscribers.push(subscriber); });
  }

  public search() {
    this.criteriaLoading = true;
    
    this.onSearch(this.query).subscribe({
      next: results => {
        this.results = results;
        this.criteriaLoading = false;
      },
      error: e => this.criteriaLoading = false
    });
  }
}